<template>
    <div class="o-map-exploration-views" :class="{'hover-over-clickable' : hoveredUnitObjects.length }">
        <div>
            <!--
                @coverClick="goToLevelView"
                @unitClick="selectUnitObjects"
                @unitMouseOver="onUnitMouseOver"

                :highlight-covers-on-mouse-over="true"
                :highlight-units-on-mouse-over="true"
            -->
            <BaseView
                v-if="mapViewer.activeView === 'OutdoorView'"
                name="OutdoorView"
                key="OutdoorView"

                :transition-duration="transitionDuration"
                :allow-rotation="getMapConfigProp('explore_camera.allow_orientation', false) || canOrient"

                :camera-orientation="getMapConfigProp('explore_camera.orientation',-9)"
                :camera-tilt="getMapConfigProp('explore_camera.tilt',35)"

                :zoom="getMapConfigProp('global_camera.zoom',3400)"
                :zoom-on-units="zoomOnUnitNames"

                :limit-max-zoom-to-units="selectedObjectsUnitNames"
                :limit-max-zoom-to="3400"
                :max-zoom-margin="0.5"

                :limit-min-zoom-to="500"

                :show-covers="true"
                :show-outdoor="showOutdoor"

                :transparent-covers="[]"

                :show-floors="outdoorFloorsIDs"
                :center-on-units="selectedObjectsUnitNames.length ? selectedObjectsUnitNames : targetZoneServicesUnitNames"
            >
                <!--
                    @transitionComplete="transitionDuration = 1"
                -->

                <!--
                     @click.native="goToLevelViewByObject(tz)"
                -->
                <MapLabel
                    v-for="tz in targetZoneServices"
                    :key="tz.id"
                    :selectedUnit="tz.unit.name"
                    target="unit"
                    position-x="middle"
                    position-y="middle"
                >
                    <img
                        class="tz-label"
                        :src="t(tz, 'icon')"
                        :alt="`${$t('target-zone')} ${t(tz, 'name')}`"
                    />
                </MapLabel>
            </BaseView>
            <!--
                :zoom-on-floors="activeFloorUnitNames"

            -->
            <!--
            <BaseView
                v-if="mapViewer.activeView === 'LevelView'"
                name="LevelView"
                key="LevelView"

                @unitClick="selectUnitObjects"

                @unitMouseOver="onUnitMouseOver"
                :highlight-units-on-mouse-over="true"

                :center-on-floors="activeFloorUnitNames"
                :center-on-units="objectsInFocusUnitNames"

                :zoom="getExploreConfig('selected_object_zoom_distance', 600)"

                :show-floors="levelViewFloorIDs"
                :fade-out-floors-except="activeLevelFloorIDs"
                :show-covers="activeLevel === 0 ? nonActiveBuildingGroupBuildingIDs : emptyArray"

                :camera-orientation="activeBuilding.meta.camera_rotation"
                :camera-tilt="32"
                :camera-zoom-margin="0.2"

                :limit-max-zoom-to-buildings="activeBuildingGroupBuildingIDs"
                :limit-max-zoom-to="3400"
                :max-zoom-margin="0.2"

                :limit-min-zoom-to="200"

                :show-outdoor="showOutdoor"
            >
                <MapLabel
                    v-for="portal in activeLevelElevatorPortals"
                    :key="portal.id"
                    :selectedUnit="portal.unit.name"
                    target="unit"
                    @click.native="onPortalClick(portal)"
                    :frame="true"
                    :black-frame-on-hover="true"
                    class="portal-label"
                >
                    <svg-icon
                        original
                        name="map-navigation/elevator"
                        style="width: 35px;height: 35px"
                    />
                </MapLabel>
                <MapLabel
                    v-for="tz in targetZoneServices"
                    :key="tz.id"
                    :selectedUnit="tz.unit.name"
                    target="unit"
                    position-x="middle"
                    position-y="middle"
                    @click.native="goToLevelViewByObject(tz)"
                >
                    <img
                        class="tz-label"
                        :src="t(tz, 'icon')"
                        :alt="`${$t('target-zone')} ${t(tz, 'name')}`"
                    />
                </MapLabel>
                <AButton
                    :text="$t('o-map-exploration-views_to-outdoor')"
                    @onClick="goToOutdoorView"
                >
                    <template #left>
                        <span class="map-exploration-views__icon-wrapper">
                            <svg-icon
                                original
                                name="icons/arrow-left"
                            />
                        </span>
                    </template>
                </AButton>
            </BaseView>
            <BaseView
                v-if="mapViewer.activeView === 'FloorSelection'"
                name="FloorSelection"
                key="FloorSelection"

                @floorClick="onFloorClick"
                @floorMouseOver="onFloorMouseOver"
                :highlight-floors-on-mouse-over="true"

                :show-floors="activeBuildingFloorsIDs"
                :center-on-floors="activeFloorUnitNames"
                :zoom-on-floors="activeBuildingFloorsIDs"

                :fade-out-floors-except="activeFloorUnitNames"
                :transparent-floors="activeLevel === 0 ? emptyArray : levelViewFloorIDs"

                :show-covers="false"

                :camera-orientation="activeBuilding.meta.camera_rotation"
                :camera-tilt="32"
                :separate-distance="35"

                :limit-max-zoom-to-floors="activeBuildingFloorsIDs"
                :limit-max-zoom-to="3400"
                :max-zoom-margin="0.4"

                :limit-min-zoom-to="500"

                :show-outdoor="showOutdoor"

            >
                <MapLabel
                    v-for="portal in activeBuildingPortals"
                    :key="portal.unit.id"
                    :selectedUnit="portal.unit.name"
                    target="unit"
                    position-x="left"
                    position-y="bottom"
                    @click.native="goToLevelViewByObject(portal)"
                >
                    <svg-icon
                        original
                        name="map-navigation/elevator"
                        style="width: 18px;height: 18px"
                    />
                    <span style="margin-left: 10px; font-size: 16px;line-height: 18px;background-color: white">{{ t(portal.floor,'name') }}</span>
                </MapLabel>
                <MapLabel
                    v-if="hoveredFloor"
                    :selectedUnit="hoveredFloorUnitName"
                    target="floor"
                    :frame="true"
                    @click.native="goToLevelView(hoveredFloor.meta.building_index, hoveredFloor.meta.level)"
                >
                    <h2>{{ t(hoveredFloor, 'name')}}</h2>
                </MapLabel>
                <AButton
                    :text="$t('o-map-exploration-views_to-level')"
                    @onClick="goToLevelViewByObject(objectsInFocus[0])"
                >
                    <template #left>
                        <span class="map-exploration-views__icon-wrapper">
                            <svg-icon
                                original
                                name="icons/arrow-left"
                            />
                        </span>
                    </template>
                </AButton>
            </BaseView>-->
        </div>

        <!--<div class="hover-labels">
            <MapLabel
                v-if="hoveredUnitObjects.length"
                :selectedUnit="hoveredUnitName"
                target="unit"
                position-x="middle"
                position-y="middle"
                frame
                class="hover-label"
                @click.native="selectUnitObjects(hoveredUnitName)"
            >
                <div
                    v-for="obj in hoveredUnitObjects"
                    :key="obj.id"
                    class="o-map-exploration-views__label-wrapper"
                >
                    <svg-icon
                        original
                        name="icons/marker"
                        class="a-guide-overview-button__marker"
                        @click.prevent="requestGuideFrom(obj)"
                    />
                    <img
                        v-if="t(obj, 'icon')"
                        :src="t(obj, 'icon')"
                        :alt="t(obj, 'name')"
                        class="o-map-exploration-views__label-img"
                    />
                    <h3>
                        {{ t(obj, 'name')}}
                    </h3>
                    <svg-icon
                        original
                        name="icons/finish-red"
                        class="a-guide-overview-button__finish"
                        @click.prevent="requestGuideTo(obj)"
                    />
                </div>
            </MapLabel>
            <div v-if="selectedObjects.length">
                <MapLabel
                    v-for="unitName in selectedObjectsUnitNames"
                    :key="unitName"
                    :selectedUnit="unitName"
                    target="unit"
                    frame
                    class="selected-object-label"
                    @click.native="selectUnitObjects(null)"
                >
                    <div
                        v-for="obj in selectedObjectsByUnitName(unitName)"
                        :key="obj.id"
                        class="o-map-exploration-views__label-wrapper"
                    >
                        <svg-icon
                            original
                            name="icons/marker"
                            class="a-guide-overview-button__marker"
                            @click.prevent="requestGuideFrom(obj)"
                        />
                        <img
                            v-if="t(obj, 'icon')"
                            :src="t(obj, 'icon')"
                            :alt="t(obj, 'name')"
                            class="o-map-exploration-views__label-img"
                        />
                        <h3>
                            {{ t(obj, 'name')}}
                        </h3>
                        <svg-icon
                            original
                            name="icons/finish-red"
                            class="a-guide-overview-button__finish"
                            @click.prevent="requestGuideTo(obj)"
                        />
                    </div>
                </MapLabel>
            </div>
        </div>-->

    </div>
</template>

<script>
import { mapGetters } from 'vuex';

// import AButton from "../../atoms/a-button/a-button";
import MapLabel from "../../../shared/components/map-viewer/labels/map-label"
import BaseView from "../../../shared/components/map-viewer/views/base/base-view";
import OutdoorView from "../../../shared/components/map-viewer/views/outdoor/outdoor-view"

import {
    REMOVE_PATH,
    MAP_SHOW_FLOOR,
    MAP_SHOW_OBJECT,
    SET_NORMALIZED_ZOOM,
    SET_GYROSCOPE_STATE,
} from "../../../shared/components/map-viewer/constants/map-commands";
import {
    MAP_OBJECT_HOVERED,
    MAP_OBJECT_SELECTED
} from "../../../shared/components/map-viewer/constants/map-events";

export default {
    name: "OMapExplorationViews",
    components: {
        // AButton,
        BaseView,
        MapLabel,
    },

    // -------------------------------- Injected ----------------------------------------
    inject: ['mapViewer'],

    // -------------------------------- Data --------------------------------------------
    data(){
        return {
            activeBuildingId: null,
            activeLevel: null,
            activeFloorUnitName: null,
            activeUnitName: null,

            objectsInFocus: [],
            floorsInFocus: [],
            selectedObjects: [],

            hoveredUnitName: null,
            hoveredFloorUnitName: null,

            zoomBasedTilt: 70,
            transitionDuration: 0,
            canOrient: false,
        }
    },

    // -------------------------------- Computed ----------------------------------------
    computed: {
        ...mapGetters([
            't',
            'getMap',
            'getMapConfig',
            'getMapConfigProp',
        ]),
        emptyArray(){
            return []
        },
        md(){
            return this.mapViewer.mapData
        },
        activeFloor(){
            return this.floors.find( f => f.meta.building_index === this.activeBuildingId && f.meta.level === this.activeLevel)
        },
        activeFloorUnitNames(){
            return this.activeFloor ? [this.activeFloor.unit.name] : []
        },
        activeFloorPortals(){
            // TODO: move allowed portal types to a guide settings
            return this.portals.filter( p => p.floor.unit_name === this.activeFloorUnitName && p.meta.portal_type === 'Elevators')
        },

        activeBuilding(){
            return this.buildings.find( b => b.meta.building_index === this.activeBuildingId)
        },
        activeBuildingFloors(){
            return this.floors.filter( f => f.meta.building_index === this.activeBuildingId)
        },
        activeBuildingFloorsIDs(){
            return this.activeBuildingFloors.map( f => f.unit.name)
        },
        activeBuildingGroupBuildings(){
            return this.activeBuilding ? this.buildings.filter( b => b.meta.building_group_id === this.activeBuilding.meta.building_group_id) : []
        },
        activeBuildingGroupBuildingIDs(){
            return this.activeBuildingGroupBuildings.map( b => b.meta.building_index)
        },
        nonActiveBuildingGroupBuildings(){
            return this.activeBuilding ? this.buildings.filter( b => b.meta.building_group_id !== this.activeBuilding.meta.building_group_id) : []
        },
        nonActiveBuildingGroupBuildingIDs(){
            return this.nonActiveBuildingGroupBuildings.map( b => b.meta.building_index)
        },

        activeLevelFloors(){
            return this.floors.filter( f => f.meta.level === this.activeLevel && this.activeBuildingGroupBuildingIDs.includes(f.meta.building_index))
        },

        activeLevelFloorIDs(){
            return this.activeLevelFloors.map( f => f.unit.name )
        },
        outdoorBuildingsIDs(){
            return this.buildings.filter( b => b.meta.is_outdoor)
        },

        outdoorFloors(){
            return this.floors.filter( f => f.meta.is_outdoor)
        },
        outdoorFloorsIDs(){
            return this.outdoorFloors.map( f => f.unit.name)
        },

        levelViewFloorIDs(){
            return this.activeLevel === 0 ? [...this.activeLevelFloorIDs, ...this.outdoorFloorsIDs] : this.activeLevelFloorIDs
        },

        levels(){
            return Array.from(this.floors.reduce((acc,f) => acc.add(f.meta.level), new Set()));
        },
        floors(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'floor');
        },
        portals(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'portal');
        },
        buildings(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'building');
        },
        hoverableObjects(){
            return this.mapViewer.mapData.objects.filter( o => ['tenant', 'service', 'portal', 'floor', 'building'].includes(o.type));
        },
        indoorBuildings(){
            return this.buildings.filter( o => !o.meta.is_outdoor);
        },
        buildingIds(){
            return this.buildings.map( b => b.meta.building_index)
        },

        targetZoneServices(){
            const tzCatId = this.getMapConfigProp('categories.target_zone_service_category')
            if(!tzCatId){
                // TODO: Add/replace with sentry logging
                console.error('Target zone category is not defined. Set it in map settings `categories.target_zone_service_category`')
                return []
            }
            return this.md.objects.filter( o => o.type === 'service' && o.lists.categories && o.lists.categories.includes(tzCatId) && !this.activeLevelFloorIDs.includes(o.floor.unit_name) && o.files.icon )
        },
        targetZoneServicesUnitNames(){
            return this.targetZoneServices.map( o => o.unit.name )
        },

        activeLevelPortals(){
            return this.portals.filter( p => this.activeLevelFloorIDs.includes(p.floor.unit_name) )
        },
        activeBuildingPortals(){
            return this.portals.filter( p => this.activeBuildingId === p.floor.building_index && p.meta.portal_type === 'Elevators' )
        },
        activeLevelElevatorPortals(){
            return this.activeLevelPortals.filter( p => p.meta.portal_type === 'Elevators' )
        },

        objectsInFocusUnitNames(){
            return this.objectsInFocus.map( o => o.unit.name )
        },
        floorsInFocusUnitNames(){
            return this.floorsInFocus.map( f => f.unit.name )
        },
        selectedObjectsUnitNames(){
            return Array.from( this.selectedObjects.reduce( (acc,o) => acc.add(o.unit.name), new Set ) )
        },
        zoomOnUnitNames(){
            return this.selectedObjectsUnitNames//.length ? this.selectedObjectsUnitNames : this.targetZoneServicesUnitNames
        },
        hoveredUnitObjects(){
            return this.hoveredUnitName ? this.hoverableObjects.filter( o => o.unit.name === this.hoveredUnitName ) : []
        },
        hoveredFloor(){
            return this.floors.find( f => f.unit.name === this.hoveredFloorUnitName )
        },
        hoveredFloorObjects(){
            return this.hoveredFloorUnitName ?
                this.hoverableObjects.reduce( (acc, obj) =>
                    obj.floor.unit_name === this.hoveredFloorUnitName && !this.selectedObjectsUnitNames.includes(obj.unit.name) && acc.add()
                ) : []
        },
        showOutdoor(){
            return this.activeLevel === null || this.getMapConfigProp('global_map.outdoor_levels', [0]).includes(this.activeLevel)
        },
        isDebug(){
            return document.location.href.includes('localhost');
        },
    },

    // -------------------------------- Methods ---------------------------------------
    methods: {
        initEventListeners() {
            this.$bus.$on(REMOVE_PATH, this.onRemovePath)
            this.$bus.$on(MAP_SHOW_FLOOR, this.showFloor)
            this.$bus.$on(MAP_SHOW_OBJECT, this.showObject)
            this.$bus.$on(SET_NORMALIZED_ZOOM, this.onZoom)
            this.$bus.$on(SET_GYROSCOPE_STATE, this.onGyroStateChange)

        },
        deactivateEventListeners() {
            this.$bus.$off(REMOVE_PATH, this.onRemovePath)
            this.$bus.$off(MAP_SHOW_FLOOR, this.showFloor)
            this.$bus.$off(MAP_SHOW_OBJECT, this.showObject)
            this.$bus.$off(SET_NORMALIZED_ZOOM, this.onZoom)
            this.$bus.$off(SET_GYROSCOPE_STATE, this.onGyroStateChange)
        },
        onGyroStateChange(isGyroEnabled){
            this.canOrient = isGyroEnabled
        },

        onFloorMouseOver(floorUnitName){
            if(floorUnitName && this.hoveredFloorUnitName !== floorUnitName)
                this.hoveredFloorUnitName = floorUnitName
            else
                this.hoveredFloorUnitName = null
        },
        onUnitMouseOver(unitName){
            if(unitName && this.hoveredUnitName !== unitName  &&!this.selectedObjectsUnitNames.includes(unitName))
                this.hoveredUnitName = unitName
            else
                this.hoveredUnitName = null
        },
        onRemovePath(){
            this.mapViewer.viewApi.remove_path()
            this.mapViewer.viewApi.restore_base_color()

            this.$store.commit('setActiveStepIndex', null);
            this.$store.commit('setActiveStep', null);
            this.$store.commit('setActivePathToState', null);

            this.$emit('changeView','OutdoorView')
        },
        onZoom(data){
            if(
                data &&
                data.mode !== 'zoom' &&
                !this.mapViewer.activeView.includes('Guide') &&
                this.mapViewer.viewApi.camera_controller.normalized_zoom > 0.4
            )
                this.goToOutdoorView()
        },
        onPortalClick(portal){
            this.resetSelected()
            this.activeBuildingId = portal.floor.building_index
            this.activeFloorUnitName = portal.floor.unit_name
            this.objectsInFocus = [portal]
            this.$emit('changeView','FloorSelection')
        },
        onFloorClick(floorUnit){
            const f = this.floors.find(f => f.unit.name === floorUnit)
            this.activeUnitName = null
            this.activeLevel = f.meta.level
            this.activeBuildingId = f.meta.building_index
            this.activeFloorUnitName = floorUnit
            this.$emit('changeView','LevelView')
        },

        goToOutdoorView(){
            this.activeBuildingId = null
            this.activeLevel = null
            this.resetSelected()
            this.$emit('changeView','OutdoorView')
        },

        goToLevelView(buildingId, level = 0){
            this.resetSelected()
            this.activeBuildingId = buildingId
            this.activeLevel = level

            this.$emit('changeView','LevelView')
        },
        goToLevelViewByObject(obj){
            this.resetSelected()

            this.activeBuildingId = obj.floor.building_index
            this.activeLevel = obj.floor.level
            this.objectsInFocus = [obj]

            this.$emit('changeView','LevelView')
        },
        showFloor({id, unit}){
            const floor = this.findFloorById(id)
            floor && this.goToLevelView(floor.meta.building_index, floor.meta.level)
        },
        showObject({id, unit}){
            const o = this.findObject(id, unit);
            o && this.goToLevelViewByObject(o)
        },
        findFloorByBuildingAndLevel(buildingId, level){},
        findFloorById(id){
            return this.floors.find( f => f.id === id)
        },
        findObject(id, unit = null){
            return this.mapViewer.mapData.objects.find( f => f.id === id && !unit || f.unit.name === unit )
        },
        selectUnitObjects(unitName){
            this.objectsInFocus = this.selectedObjects = unitName ? this.hoverableObjects.filter( o => o.unit.name === unitName ) : []
        },
        selectedObjectsByUnitName(unitName){
            return this.selectedObjects.filter( o => o.unit.name === unitName)
        },

        requestGuideTo(obj){
            if (parseInt(this.$route.query.to, 10) === obj.id) return;
            const params = {
                name: `${this.$route.name.split('.')[0]}.guide`,
                params: {
                    type: 'start'
                },
                query: {
                    to: obj.id
                }
            };
            this.activeLevel = null
            this.activeBuildingId = null
            this.resetSelected()
            this.$router.push(params)
        },
        requestGuideFrom(obj){
            if (parseInt(this.$route.query.from, 10) === obj.id) return;
            const params = {
                name: `${this.$route.name.split('.')[0]}.guide`,
                params: {
                    type: 'start'
                },
                query: {
                    from: obj.id
                }
            };
            this.$router.push(params)
        },
        resetSelected(){
            this.objectsInFocus = []
            this.selectedObjects = []
            this.hoveredUnitName = null
            this.hoveredFloorName = null
        },
        getExploreConfig(prop, def){
            return _.get( this.mapViewer.mapData.config, `explore_camera.${prop}`, def)
        }
    },

    // -------------------------------- Watch ---------------------------------------
    watch:{
        hoveredUnitObjects(){
            this.hoveredUnitObjects.forEach( o => this.$bus.$emit(MAP_OBJECT_HOVERED , o))
        },
        objectsInFocus(){
            this.objectsInFocus.forEach( o => this.$bus.$emit(MAP_OBJECT_SELECTED, o))
        },

    },

    // -------------------------------- Hooks ---------------------------------------
    mounted() {
        this.initEventListeners()
        setTimeout(() => this.transitionDuration = 1.4 , 2000)
    },
    beforeDestroy() {
        this.deactivateEventListeners()
    },
}
</script>
<style lang="scss">
  @import "o-map-exploration-views";
</style>

